export default {
    'name': 'fireWrapper',
    'label': 'legal.tabs.FileWrapper',
    'getComponent': () => import('./file-wrapper.vue'),
    'tabIndex': 3,
    'left': true,
    'right': true,
    'singleView': true,
    'exclusiveRoutePath': '/legal/file-wrapper',
    'aclCheckKey': 'legal',
};
